import React, { useEffect, useState } from "react";
import "./Philosophy.css";
import "@fontsource/source-sans-pro";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import MainBanner from "./components/MainBanner/MainBanner";
import img from "./assets/images/img.webp";
import img1 from "./assets/images/img1.webp";
import Banner from "./components/Banner/Banner";
import { Helmet } from "react-helmet-async";

const Philosophy = () => {
  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);

  const [activeLine, setActiveLine] = useState(0);
  const lines = [
    "Harer Nāma Harer Nāma",
    "Harer Nāmaiva Kevalam",
    "Kalau Nāsty Eva Nāsty Eva",
    "Nāsty Eva Gatir Anyathā",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveLine((prev) => (prev + 1) % lines.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Helmet>
        <title>ISKCON Vijayawada Philosophy – Krishna Conscious Living</title>
        <meta
          name="description"
          content="Delve into ISKCON Vijayawada’s core philosophy of Krishna consciousness based on the Bhagavad Gita, bhakti yoga, and Vedic wisdom for modern life."
        />
        <meta
          name="keywords"
          content="Krishna philosophy, ISKCON philosophy, bhakti yoga teachings, Vedic wisdom ISKCON"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="ISKCON Vijayawada Philosophy – Krishna Conscious Living"
        />
        <meta
          property="og:description"
          content="Delve into ISKCON Vijayawada’s core philosophy of Krishna consciousness based on the Bhagavad Gita, bhakti yoga, and Vedic wisdom for modern life."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/philosophy"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="ISKCON Vijayawada Philosophy – Krishna Conscious Living"
        />
        <meta
          name="twitter:description"
          content="Delve into ISKCON Vijayawada’s core philosophy of Krishna consciousness based on the Bhagavad Gita, bhakti yoga, and Vedic wisdom for modern life."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/philosophy"
        />
      </Helmet>

      <Header />
      <div className="philosophy-page md:mt-8">
        <MainBanner />
        <div className="d-flex justify-content-center philosophy-img">
          <div className="text-center">
            <div className="d-flex justify-content-center">
              <img
                loading="lazy"
                src={img}
                alt="Sankirtan for goodwill"
                className="philosophy"
                style={{
                  padding: "5rem",
                }}
              />
            </div>
            <div className="headline font-serif">
              {lines.map((line, index) => (
                <p
                  key={index}
                  className={`text-2xl transition-all duration-700 ease-in-out my-4
            ${
              activeLine === index
                ? "text-[#c61d21] text-4xl"
                : "text-black scale-100"
            }
          `}
                  style={{
                    transformOrigin: "left center",
                  }}
                >
                  {line}
                </p>
              ))}
            </div>
            <div className="d-flex justify-content-center">
              <img
                loading="lazy"
                src={img1}
                alt="Lord Chaitanya is the divine union of Radha and Krishna."
                className="philosophy"
                style={{
                  padding: "5rem",
                }}
              />
            </div>
          </div>
        </div>
        <Banner />
      </div>
      <Footer />
    </>
  );
};

export default Philosophy;
